<h1 mat-dialog-title>{{ data?.title }}</h1>
<div mat-dialog-content>
  <p>{{ data?.text }}</p>
  <form [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input type="email" matInput formControlName="email" autocomplete="off" />
    </mat-form-field>
  </form>
</div>
<div id="actions" mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()" class="btn-secundary">
    Cancelar
  </button>
  <button
    mat-button
    (click)="sendEmailToRequestPassword()"
    cdkFocusInitial
    class="btn-primary"
  >
    enviar
  </button>
</div>
